import React from 'react';
import { Redirect } from 'react-router-dom';
import { propOr } from 'ramda';
import useSignUpToken from '../../hooks/useSignUpToken';
import SignUp from './SignUp';

const SignUpWithToken = (props) => {
  const { isValidToken, email, token } = useSignUpToken(propOr({}, 'location', props));

  if (isValidToken === null) { return <div>Loading...</div>; }
  if (!isValidToken) { return <Redirect to="/account/lien-invalide" />; }

  return <SignUp {...props} email={email} token={token} />;
};

export default SignUpWithToken;
